import { render } from 'react-dom';
import AppRouter from 'App';

render((
	<AppRouter/>
), document.getElementById('root'));
